import { BinListAction } from "./action";
import { BinListState, binListState } from "./state";

export function BinListReducer(
  state: BinListState = binListState,
  action: BinListAction
): BinListState {
  switch (action.type) {
    case "@@InitBinListState/InitBinListAction":
      return {
        ...state,
        binListRootState: action.binListState,
      };

    case "@@InitBinListState/InitBinDetailAction":
      return {
        ...state,
        selectedBinItem: action.binDetail,
      };

    case "@@InitBinListState/initBinGroupListAction":
      return {
        ...state,
        binGroupList: action.BinGroupList,
      };


    case "@@InitBinListState/ChangeBinNameAction":
      const newLocationCn = action.name;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          location_cn: newLocationCn,
        },
      };

    case "@@InitBinListState/ChangeBinEngNameAction":
      const newLocationEn = action.name;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          location_en: newLocationEn,
        },
      };
    case "@@InitBinListState/ChangeBinEmailAction":
      const newEmail = action.email;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          email: newEmail,
        },
      };

    case "@@InitBinListState/ChangeBinContactPersonAction":
      const newContactPerson = action.contact_person;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          contact_person: newContactPerson,
        },
      };

    case "@@InitBinListState/ChangeBincCodeAction":
      const newCode = action.code;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          code: newCode,
        },
      };
    case "@@InitBinListState/ChangeBincLatAction":
      const newLat = action.lat;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          lat: newLat.toString(),
        },
      };

    case "@@InitBinListState/ChangeBincLonAction":
      const newLon = action.lon;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          lon: newLon.toString(),
        },
      };

    case "@@InitBinListState/ChangeBinRemarkAction":
      const newReamark = action.remark;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          remarks: newReamark,
        },
      };

    case "@@InitBinListState/ChangeBinContractAction":
      const newContract_id = action.contract_id;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          contract_id: parseInt(newContract_id),
        },
      };

    case "@@InitBinListState/ChangeDistrictIdAction":
      const data = action.data;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          district_id: data.district_id,
          area_id: data.area_id,
        },
      };
    case "@@InitBinListState/ChangeBinTypeAction":
      const bin_type_id = action.bin_type_id;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          bin_type_id: parseInt(bin_type_id),
        },
      };

    case "@@InitBinListState/ChangeBinStatusAction":
      const status = action.status;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          status: parseInt(status),
        },
      };

    case "@@InitBinListState/ChangeSelectedZoneIdAction":
      const zone_id = action.zone_id;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          zone_id: zone_id,
        },
      };

    case "@@InitBinListState/ChangeSelectedToiletNumberAction":
      const toilet_number = action.toilet_number;
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          toilet_number: toilet_number,
        },
      };

    case "@@InitBinListState/ChangeBinHistoryAction":
      return {
        ...state,
        selectedBinItemHistory: action.binHistoryList,
      };


    case "@@InitBinListState/ClearSelectedBinAction":
      return {
        ...state,
        selectedBinItem: {
          ...state.selectedBinItem,
          bin_id: null,
          bin_type: "",
          value: null,
          label: "",
          code: "",
          location_cn: "",
          location_en: "",
          email: "",
          lat: "",
          lon: "",
          district_id: null,
          area_id: null,
          bin_type_id: null,
          contract_id: null,
          contract: "",
          zone_id: null,
          zone_name: "",
          status: null,
          remarks: "",
          create_by: null,
          create_date: "",
          toilet_number: "",
        },
      };
    default:
      return state;
  }
}
